// extracted by mini-css-extract-plugin
export default {"app":"app__JwGpD","text-center":"text-center__sgVfL","error-color":"error-color__SX6ur","loading":"loading__EGQys","wrapper":"wrapper__IeqUF","header":"header__8Qqmt"};